(() => {
 if (window.ntJudgeReviewNavigation) return;
 window.ntJudgeReviewNavigation = true;
 const dateSelector = '.jm-reviewer-info__details .jm-text:not(.jm-reviewer-info__name)';
 const isDate = text => /^(?:\d{1,4}[\/.-]){2}\d{1,4}$/.test(text.trim());
 const hideDates = scope => {
  if (!(scope instanceof Element || scope instanceof Document)) return;
  const candidates = [...scope.querySelectorAll(dateSelector)];
  if (scope instanceof Element && scope.matches(dateSelector)) candidates.push(scope);
  candidates.forEach(element => {
   if (isDate(element.textContent || '')) element.setAttribute('data-nt-judge-date', '');
  });
 };
 hideDates(document);
 new MutationObserver(records => {
  for (const record of records) {
   if (record.type === 'characterData') hideDates(record.target.parentElement);
   else record.addedNodes.forEach(node => hideDates(node.nodeType === Node.TEXT_NODE ? node.parentElement : node));
  }
 }).observe(document.body, {childList: true, subtree: true, characterData: true});
 document.addEventListener('click', event => {
  const rating = event.target.closest('[data-nt-judgeme-rating]');
  if (!rating) return;
  const root = rating.closest('[data-nt-product]');
  const tab = root?.querySelector('[data-nt-product-tab="reviews"]');
  if (tab) tab.click();
  root?.querySelector('#judgeme_product_reviews')?.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion:reduce)').matches ? 'instant' : 'smooth', block: 'center' });
 }, true);
})();
